import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GrupoConocimiento } from 'src/app/domain/model/catalogo/grupo-conocimiento';

/**
 * Adaptador HTTP: HttpGrupoConocimientoRepository
 *
 * Servicio para comunicación HTTP con el catálogo de Grupos de Conocimiento.
 * Endpoint: GET /api/servicios/grupos-conocimiento
 */
@Injectable({ providedIn: 'root' })
export class HttpGrupoConocimientoRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/grupos-conocimiento`;

  /** Lista todos los grupos de conocimiento activos. */
  async listarActivos(): Promise<GrupoConocimiento[]> {
    return firstValueFrom(
      this.http.get<GrupoConocimiento[]>(this.baseUrl)
    );
  }
}
